import {z as zod} from "zod";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {VariantCompatibilityLinkStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/flexibleFitmentEngineWorkspaceCapability/domain/FlexibleFitmentEngine";

export type VariantCompatibilityLink = {
    createdAt: Iso8601DateTime;
    id: Uuid;
    masterNodeId: Uuid;
    productCatalogueId: Uuid;
    revisionId: Uuid;
    status: VariantCompatibilityLinkStatus;
    updatedAt: Iso8601DateTime;
};

export const variantCompatibilityLinkValidator: zod.ZodType<VariantCompatibilityLink> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    id: uuidZodValidator,
    masterNodeId: uuidZodValidator,
    productCatalogueId: uuidZodValidator,
    revisionId: uuidZodValidator,
    status: zod.enum(VariantCompatibilityLinkStatus),
    updatedAt: iso8601DateTimeZodValidator,
});
